<template>
  <!-- Figma row 3 left: green filled success check + centered body -->
  <v-container fluid class="pa-0 fill-height vc-tv-canvas-bg vc-incoming-root">
    <PatientBackground />

    <v-sheet
      class="vc-incoming-panel vc-confirm-rail d-flex flex-column bg-white"
      elevation="24"
      height="100%"
      rounded="0"
    >
      <v-icon class="vc-confirm-icon vc-confirm-icon--success">mdi-check-circle</v-icon>
      <p class="vc-confirm-body">
        Your nurse has been notified. They'll call you as soon as possible.
      </p>
    </v-sheet>
  </v-container>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import PatientBackground from '../components/PatientBackground.vue'

const router = useRouter()

onMounted(() => {
  setTimeout(() => router.push('/'), 4000)
})
</script>
